<template>
  <div class="site-wrapper site-page--not-found">
    <div class="site-content__wrapper">
      <div class="site-content">
        <img src="@/assets/blue_sad.png" width="200px" />
        <!-- <h2 class="not-found-title">{{ errorCode }}</h2> -->
        <p class="not-found-desc">
          抱歉，操作失败!
          <br />失败原因：[Code: {{ errorCode }}] <br /><em>{{ errorMsg }}</em>
        </p>
        <el-button @click="$router.go(-1)">返回上一页</el-button>
        <el-button
          type=""
          class="not-found-btn-gohome"
          @click="$router.push('/')"
          >进入首页</el-button
        >
        <el-button
          type=""
          class="not-found-btn-gohome"
          @click="$router.push('/login')"
          >重新登录</el-button
        >
        <div style="padding-top:20px;">
          获取更多帮助，请联系我们：
          <span
            ><a
              target="_blank"
              href="http://amos.alicdn.com/msg.aw?v=2&amp;uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&amp;site=cntaobao&amp;s=1&amp;charset=utf-8"
              ><img
                border="0"
                src="http://amos.alicdn.com/online.aw?v=2&amp;uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&amp;site=cntaobao&amp;s=1&amp;charset=utf-8"
                alt="点击这里给我发消息"
            /></a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {
      errorCode: 0,
      errorMsg: "未知错误"
    };
  },
  mounted() {
    //console.log("this.$route.query", this.$route.query);
    this.errorCode = this.$route.query.code;
    this.errorMsg = this.$route.query.msg;
  }
};
</script>

<style lang="scss">
.site-wrapper.site-page--not-found {
  position: absolute;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  .site-content__wrapper {
    padding: 0;
    margin: 0;
    background-color: #fff;
  }
  .site-content {
    position: fixed;
    top: 15%;
    left: 50%;
    z-index: 2;
    padding: 30px;
    text-align: center;
    transform: translate(-50%, 0);
  }
  .not-found-title {
    margin: 20px 0 15px;
    font-size: 8em;
    font-weight: 500;
    color: rgb(55, 71, 79);
  }
  .not-found-desc {
    margin: 0 0 30px;
    font-size: 26px;
    text-transform: uppercase;
    color: rgb(118, 131, 143);
    line-height: 50px;
    > em {
      font-style: normal;
      color: #ee8145;
    }
  }
  .not-found-btn-gohome {
    margin-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Public/Error.vue